import { Link, LinkProps } from 'react-scroll';

import { useDevice } from '@contexts/device';

const ScrollLink = ({
  children,
  activeClass = 'active',
  className,
  spy = true,
  smooth = true,
  duration = 500,
  to,
}: React.PropsWithChildren<React.PropsWithChildren<LinkProps>>) => {
  const { isDesktop } = useDevice();
  return (
    <Link
      activeClass={activeClass}
      className={className}
      to={to}
      spy={spy}
      smooth={smooth}
      duration={duration}
      offset={isDesktop ? -100 : -220}
      style={{ transition: '0.15s' }}
    >
      {children}
    </Link>
  );
};

export default ScrollLink;
